import { render, staticRenderFns } from "./AssistMaterialPractice.vue?vue&type=template&id=14934d84&scoped=true&lang=pug&"
import script from "./AssistMaterialPractice.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterialPractice.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterialPractice.vue?vue&type=style&index=0&id=14934d84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14934d84",
  null
  
)

export default component.exports